import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    // cardWithHover: {
    //   '& .MuiPaper-root:hover': {
    //     boxShadow: '20', // theme.shadows[20],
    //     backgroundColor: 'green'
    //   }
    // }
  })
